import { useHistory } from 'react-router-dom';
import AppLayout from '../../../../../../component/appLayout';
import { getUrlParam, isEmpty } from '../../../../../../helpers/common';
import { useCallback, useEffect } from 'react';
import { vercelIntegration } from '../../../../../../services/vercelService';
import { ROUTES } from '../../../../../../routes/urls';
import { rootStore } from '../../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

function VercelAuth() {
  // mobx states
  const { currentWorkspace } = rootStore.workspaceStore || {};

  // Other variables
  const history = useHistory();

  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      const code = getUrlParam(history.location.search, 'code');
      const teamId = getUrlParam(history.location.search, 'teamId');
      const configurationId = getUrlParam(history.location.search, 'configurationId');
      if (code && teamId && configurationId) {
        const payload = { code, teamId, configurationId };
        const response = await vercelIntegration(payload);
        if (response) {
          history.push(ROUTES.VERCEL_INTEGRATION_DETAILS);
        }
      }
    }
  }, [history, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return <AppLayout>Loading ...</AppLayout>;
}

export default observer(VercelAuth);
